import React, { useState, useRef, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import { LegalRequirementsTable } from "../../../components/Admin/LegalRequirements";
import { ManagementModuleTitle } from "../../../components/Shared";
import { useAuth } from "../../../hooks";
import { useCompany } from "../../../contexts/CompanyContext";
import { useLanguage } from "../../../contexts";
import "./LegalRequirements.scss";

export function LegalRequirements() {
  const [reload, setReload] = useState(false);
  const [year,   setYear]   = useState(new Date().getFullYear());
  const onReload = () => setReload((prev) => !prev);

  const { user: { role } } = useAuth();
  const { company } = useCompany();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 6 }, (_, i) => currentYear - 2 + i).reverse();

  const hasCompany = company && company !== "0" && company !== 0;

  const [showYearMenu, setShowYearMenu] = useState(false);
  const yearMenuRef = useRef(null);

  useEffect(() => {
    if (!showYearMenu) return;
    const handler = (e) => {
      if (yearMenuRef.current && !yearMenuRef.current.contains(e.target))
        setShowYearMenu(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [showYearMenu]);

  return (
    <div className="legal-requirements-page">
      <div className="legal-requirements-page__title-bar">
        <ManagementModuleTitle labelClassName="legal-requirements-page__title" />
      </div>

      <div className="legal-requirements-page__year-bar" ref={yearMenuRef}>
        <button
          type="button"
          className="legal-requirements-page__year-bar__toggle"
          onClick={() => setShowYearMenu((v) => !v)}
        >
          <span className="legal-requirements-page__year-bar__label">{year}</span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="20" height="20" className={`legal-requirements-page__year-bar__arrow${showYearMenu ? " legal-requirements-page__year-bar__arrow--open" : ""}`}>
            <circle cx="12" cy="12" r="9"/>
            <path d="M12 8v6m0 0-2.5-2.5M12 14l2.5-2.5"/>
          </svg>
        </button>

        {showYearMenu && (
          <div className="legal-requirements-page__year-menu">
            {yearOptions.map((y) => (
              <button
                type="button"
                key={y}
                className={`legal-requirements-page__year-menu__item${y === year ? " legal-requirements-page__year-menu__item--active" : ""}`}
                onClick={() => { setYear(y); setShowYearMenu(false); }}
              >
                {y}
              </button>
            ))}
          </div>
        )}
      </div>

      {hasCompany ? (
        <LegalRequirementsTable
          reload={reload}
          onReload={onReload}
          role={role}
          extYear={year}
        />
      ) : (
        <div className="no-site-warning">
          <Icon name="building outline" />
          <p>{t("select_company_from_header") || "Selecciona una empresa desde el encabezado"}</p>
        </div>
      )}
    </div>
  );
}
